import { render, staticRenderFns } from "./DocCatergories.vue?vue&type=template&id=7a7bc6a8"
import script from "./DocCatergories.vue?vue&type=script&lang=js"
export * from "./DocCatergories.vue?vue&type=script&lang=js"
import style0 from "./DocCatergories.vue?vue&type=style&index=0&id=7a7bc6a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports